module.exports = __webpack_public_path__ + "static/img/xa.80d226b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xa.png
// module id = 0qJN
// module chunks = 0